// eslint-disable-next-line @typescript-eslint/class-name-casing
// these locales are not supported by Intl library of NodeJs
export var customLocales = [{
  code: 'en-EEA',
  country: 'European Economic Area',
  language: 'English',
  region: 'EuropeanEconomicArea',
  languageCode: 'en',
  baseName: 'en-EEA'
}];
export function getIntlInfo(locale) {
  // check for custom Locale
  var customLocale = locale && customLocales.find(function (_ref) {
    var code = _ref.code;
    return code === locale;
  });

  if (customLocale) {
    var _locale = customLocale.code,
        country = customLocale.country,
        _language = customLocale.language,
        _region = customLocale.region,
        languageCode = customLocale.languageCode,
        _baseName = customLocale.baseName;
    return {
      locale: _locale,
      country: country,
      language: _language,
      languageCode: languageCode,
      region: _region,
      baseName: _baseName
    };
  }

  var INTL = Intl; // typecasted to any because Typescript version used inside this project does not support Locale, DisplayNames

  var _INTL$Locale = new INTL.Locale(locale),
      language = _INTL$Locale.language,
      region = _INTL$Locale.region,
      baseName = _INTL$Locale.baseName; // NOTE: REQUIRES NODE.JS v14 FOR THIS TO WORK


  var displayNameCountry = new INTL.DisplayNames(['en'], {
    type: 'region'
  });
  var displayNameLanguage = new INTL.DisplayNames(['en'], {
    type: 'language'
  });
  return {
    locale: locale,
    country: region ? displayNameCountry.of(region) : undefined,
    language: displayNameLanguage.of(language),
    languageCode: language,
    region: region,
    baseName: baseName
  };
}